import axios from "axios";
import { ADMIN_PORTAL_API_BASE_URL, ADMIN_PORTAL_AUTH_TOKEN } from "../utils/config";


export const getCta = async (source) => {
    let config = {
        method: "post",
        url: `${ADMIN_PORTAL_API_BASE_URL}/get_cta`,
        headers: {
            Authorization: "Bearer " + ADMIN_PORTAL_AUTH_TOKEN
        },
        data: {
            source: source
        }
    };
    try {
        const response = await axios(config);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}